import { type ReactNode, useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { useSessionStore } from '@/entities/session';
import { useVerificationInfoModal } from '@/entities/verification';

type Props = {
  children: ReactNode;
  redirectTo?: string;
};

export function VerificationGuard({ children, redirectTo = '/' }: Props) {
  const { session } = useSessionStore();
  const isVerified = session?.additional?.isVerified || false;
  const { openVerificationInfoModal } = useVerificationInfoModal();
  const isModalOpenedRef = useRef(false);

  useEffect(() => {
    if (!isVerified && !isModalOpenedRef.current) {
      isModalOpenedRef.current = true;
      openVerificationInfoModal();
    }
  }, [isVerified, openVerificationInfoModal]);

  if (!isVerified) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
